import { Show, type JSX } from "solid-js";

/**
 * En-tête : le logo et le nom du site, qui ramènent à l'accueil, puis sur la même
 * ligne la navigation passée en enfant. Le logo est celui de l'onglet
 * (public/favicon.svg). L'apparence se règle dans Paramètres.
 */
export function Entete(props: { surAccueil?: () => void; children?: JSX.Element }) {
  const enseigne = (
    <>
      <img class="enseigne-logo" src="/favicon.svg" alt="" width="30" height="30" />
      <span class="enseigne-nom">ParsadaMap</span>
    </>
  );
  return (
    <header class="entete">
      <div class="titre">
        <h1 class="enseigne">
          <Show when={props.surAccueil} fallback={enseigne}>
            {(surAccueil) => (
              <button
                type="button"
                class="enseigne-lien"
                title="Retour à l'accueil"
                onClick={() => surAccueil()()}
              >
                {enseigne}
              </button>
            )}
          </Show>
        </h1>
      </div>
      {props.children}
    </header>
  );
}
